<!-- 课程 -->
<template>
    <el-dialog v-dialogDrag :title="title" :visible.sync="dialogVisible" width="550px" top="200px"
        :modal-append-to-body="false">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
           
            <el-form-item label="审核结果" prop="audit_state">
                <el-select v-model="ruleForm.audit_state" placeholder=""  style="width:100%">
                    <el-option v-for="item in options.filter(item => item.dictionary_key != 1)" :key="item.dictionary_key" :label="item.dictionary_value"
                        :value="item.dictionary_key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="请输入原因" prop="audit_fail_reason" v-if="ruleForm.audit_state == 3">
                <el-input v-model="ruleForm.audit_fail_reason"></el-input>
            </el-form-item>
        </el-form>

        <!-- v-if  从新渲染 -->
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleOk">确 定</el-button>
            <el-button @click="dialogVisible = false">取 消</el-button>

        </span>
    </el-dialog>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {
            dialogVisible: false,
            title: '审核',
            ruleForm: {
                "id": "",
                "audit_state": "",
                "audit_fail_reason": ""
            },
           
            options: [],
            rules: {
                audit_fail_reason: [
                    { required: true, message: '请输入原因', trigger: 'blur' },

                ],
                audit_state: [
                    { required: true, message: '请选择审核结果', trigger: 'change' },
                ],
            }
        }
    },
    created() {

    },
    methods: {
        // 获取数据字典值
        async getDictsData(dict, optionsNmae) {
            let options = [];
            await this.$tools
                .asyncPost(this, this.$baseUrl.dictinfogetbycode, {
                    data: {
                        dictionary_code: dict,
                    },
                })
                .then((res) => {
                    if (res.data.code == 0) {
                        options = res.data.data.dictionary_detail;
                    } else {
                        // this.$message({ type: "error", message: res.data.msg });
                    }
                })
                .catch((err) => {
                    // this.$message({ type: "error", message: err });
                });
            this[optionsNmae] = options;
        },
        init(data) {
            this.getDictsData("TM-TC-SHZT", "options");
            this.ruleForm = {
                "id": data.id,
                "audit_state": "",
                "audit_fail_reason": ""
            }
           
           
          
        },
        handleClose(done) {

            done();

        },
        handleOk() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                   
                    this.$tools
                        .asyncPost(
                            this,
                            this.$baseUrl.courseReview, {
                            data: this.ruleForm
                        }).then((res) => {
                            if (res.data.code == 0) {
                                this.$message({ type: "success", message: '审核成功' });
                                this.$emit('ok')
                                this.dialogVisible = false


                            } else {
                                this.$message({ type: "error", message: res.data.msg });
                            }
                        }).catch((err) => {
                            // this.loading = false; 
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        recursion(arr) {
            let obj;
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].options) {
                    obj = this.recursion(arr[i].options)
                    if (obj) {
                        return obj
                    }
                }
                if (arr[i].enterprise_id && arr[i].enterprise_id == this.postForm.enterprise_id) {
                    // obj = arr[i]

                    return arr[i];
                }
            }

        },
        handleChange(value) {
            console.log(value);
            let obj = this.recursion(this.options)

            this.ruleForm.enterprise_name = obj.enterprise_name
        },

        getOptions() {


            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.trainingOutlineTree, {
                    data: this.postForm3
                }).then((res) => {
                    if (res.data.code == 0) {
                        res.data.data.forEach(item => {
                            item.fold = true
                        })
                        this.options = res.data.data


                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                    this.loading = false;
                }).catch((err) => { this.loading = false; });
        },
    }
}
</script>

<style lang="less" scoped>
/deep/ .box {
    .el-form-item__content {
        margin-left: 0 !important;
    }
}
</style>
